import { connect } from 'react-redux';
import ReportsAllClients from './index';
import { mapStateToProps, mapDispatchToProps } from './index.props';

export default connect(mapStateToProps, mapDispatchToProps)(ReportsAllClients);
